export default class ScrollObserver {
    /*
     * triggers callback once, when element is near viewport
     */
    static onLazyLoad(element, callback) {
        ScrollObserver._observe(element, callback, {
            root: null, // observing changes in the viewport
            rootMargin: '800px 0px 800px 0px', // start autoplay if near viewport
            threshold: 0.01 // trigger callback if even slightly visible
        });
    }

    /*
     * triggers callback once, when element is near viewport
     */
    static onMostlyVisible(element, callback) {
        ScrollObserver._observe(element, callback, {
            root: null, // observing changes in the viewport
            rootMargin: '0px 0px 0px 0px', // start when in viewport
            threshold: 0.6 // trigger callback if well inside viewport
        });
    }

    static _observe(element, callback, options) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    callback(entry);
                    observer.disconnect(); // stop observing after the alert
                }
            });
        }, options);
        observer.observe(element);
    }

}
